import { REST_API as createRestAPI } from "@enfusion-ui/core";
import { restServer } from "./restServer";
export const REST_API = createRestAPI(restServer);
